export const mapping = {
  "webform": "routeWebform",
  "slug": "routeSlug",
  "nodeContact": "routeNodeContact",
  "nodePage": "routeNodePage",
  "nodePressRelease": "routeNodePressRelease",
  "nodeEvent": "routeNodeEvent",
  "nodeCanonical": "routeNodeCanonical"
}